<template>
  <div class="header">
    <div class="logo-container">
      <h1>
        <div class="header-logo">U+</div>
        <div>온라인 가입신청</div>
      </h1>
      <!---
      <label class='env'>{{this.environment}}</label>
      <label @click='goToIntroPage' class='env'>| TO INTRO(TEMP)</label>

      <label class='env'>| RegistrationType : {{$store.state.openMarketInfo.registrationTypeCode}} {{$store.state.openMarketInfo.registrationTypeName}}</label>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistrationHeader',

  computed: {
    environment() {
      return process.env.VUE_APP_ENV
    }
  },

  methods: {
    /** 
     * Function    : goToIntroPage
     * Description : 초기화면으로 보내기
     **/
    goToIntroPage() {
      this.$router.push({
        name: 'SamsungLayout'
      })
    }
  }
}
</script>

<style scoped></style>
